import React from 'react';

const SvgPreviewProjectBackground: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1605 1548" {...props}>
      <defs>
        <clipPath id="previewProjectBackground_svg__a">
          <path transform="translate(-.178 -.153)" d="M0 0h1605v1548H0z" />
        </clipPath>
      </defs>
      <g
        transform="translate(.178 .153)"
        clipPath="url(#previewProjectBackground_svg__a)"
      >
        <path d="M132.24 1439.296c127.216 137.672 377.735 148.2 510.936 7.07 87.778-93 128.339-173.017 224.263-234.748 109.042-70.176 199.053-60.059 326.239 10.224 103.731 57.325 300.781 64.154 377.842-70.283 80.084-139.7-2.614-255.8-50.823-324.625s-158.683-204.36-79.071-373.714c79.459-169.031 65.646-377.419-100.543-435.57-183.936-64.363-354.178 47.382-392.654 369.5-30.75 257.41-272.723 211.889-470.665 224.01-186.376 11.415-369.942 124.858-430.859 258.789-58.724 129.108-92.814 376.559 85.336 569.347" />
      </g>
    </svg>
  );
};

export default SvgPreviewProjectBackground;
